import {
  APIFieldAttributes,
  APITagAttributes,
  APIWorkspaceAttributes,
  ArdoqId,
} from '@ardoq/api-types';
import { combineLatest } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import {
  referenceTypesByWorkspaceId$,
  type ReferenceTypesByWorkspaceId,
} from 'streams/models/referenceTypesByWorkspaceId$';
import {
  componentTypesByWorkspaceId$,
  type ComponentTypesByWorkspaceId,
} from 'streams/models/componentTypesByWorkspaceId$';
import { fields$ } from 'streams/fields/fields$';
import { tags$ } from 'streams/tags/tags$';
import { persistentWorkspaces$ as workspaces$ } from 'streams/workspaces/workspaces$';

export type GroupingRuleLabelData = {
  workspacesById: Readonly<Record<ArdoqId, APIWorkspaceAttributes>>;
  referenceTypesByWorkspaceId: ReferenceTypesByWorkspaceId;
  componentTypesByWorkspaceId: ComponentTypesByWorkspaceId;
  fieldsById: Readonly<Record<ArdoqId, APIFieldAttributes>>;
  tagsById: Readonly<Record<ArdoqId, APITagAttributes>>;
};

export const groupingRuleLabelData$ = combineLatest([
  workspaces$,
  referenceTypesByWorkspaceId$,
  componentTypesByWorkspaceId$,
  fields$,
  tags$,
]).pipe(
  map(
    ([
      workspaces,
      referenceTypesByWorkspaceId,
      componentTypesByWorkspaceId,
      fields,
      tags,
    ]): GroupingRuleLabelData => ({
      workspacesById: workspaces.byId,
      referenceTypesByWorkspaceId,
      componentTypesByWorkspaceId,
      fieldsById: fields.byId,
      tagsById: tags.byId,
    })
  ),
  shareReplay({ bufferSize: 1, refCount: true })
);
